/* Animate only the placeholder: never write to the customer's search query. */
(function () {
 'use strict';
 function init(scope) {
  scope.querySelectorAll('[data-amm-typing-search]').forEach(function(input) {
   if(input.dataset.typingReady)return; input.dataset.typingReady='1';
   if(input.dataset.searchAnimate==='false')return;
   var words=(input.dataset.searchWords||'Jewellery,Fashion').split(',').map(function(s){return s.trim();}).filter(Boolean);
   if(!words.length)return;
   var motion=window.matchMedia('(prefers-reduced-motion: reduce)'),timer,index=0,pos=0,deleting=false;
   var fallback=input.placeholder||'Search products';
   function stop(){clearTimeout(timer);}
   function active(){return input.isConnected&&!document.hidden&&document.activeElement!==input&&!input.value&&!motion.matches;}
   function tick(){
    stop();if(!active())return;
    var word=words[index];pos+=deleting?-1:1;input.placeholder='Search for '+word.slice(0,pos);
    var delay=deleting?55:100;
    if(!deleting&&pos===word.length){deleting=true;delay=1600;}
    else if(deleting&&pos===0){deleting=false;index=(index+1)%words.length;delay=350;}
    timer=setTimeout(tick,delay);
   }
   function resume(){stop();if(motion.matches){input.placeholder=fallback;return;}if(active())timer=setTimeout(tick,300);}
   input.addEventListener('focus',function(){stop();input.placeholder=fallback;});
   input.addEventListener('input',function(){stop();});input.addEventListener('blur',resume);
   document.addEventListener('visibilitychange',resume);
   if(motion.addEventListener)motion.addEventListener('change',resume);
   if(input.form)input.form.addEventListener('reset',function(){setTimeout(resume,0);});
   resume();
  });
 }
 init(document);document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();
